import React from 'react';
import { Tooltip, Typography, TypographyProps } from '@mui/material';

interface Props extends TypographyProps {
  maxLines: number;
  content: string;
}

export const LineClampContent: React.FC<Props> = ({
  maxLines,
  content,
  variant = 'body2',
  fontWeight = 600,
}) => (
  <Tooltip title={content}>
    <Typography
      variant={variant}
      component="span"
      fontWeight={fontWeight}
      sx={{
        display: '-webkit-box',
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        textAlign: 'left',
      }}
    >
      {content}
    </Typography>
  </Tooltip>
);
